import { ActivityIndicator } from 'react-native';

/** Loading spinner. Color is set via the `accent-*` prop per Uniwind. */
export function Spinner({
  size = 'small',
  colorClassName = 'accent-signal',
  className,
}: {
  size?: 'small' | 'large';
  colorClassName?: string;
  className?: string;
}) {
  return (
    <ActivityIndicator
      size={size}
      colorClassName={colorClassName}
      className={className}
    />
  );
}
